import get from "lodash.get";

import { isLocal } from "@components/Constants";
import { getConfig } from "@components/Config";

type LinkTemplates = {
  softCommitmentUrl?: string;
};

type Organization = {
  id: string;
  domain: string;
  linkTemplates?: LinkTemplates;
};

const EXTERNAL_INVESTOR_PORTAL_ENABLED_ORG_IDS = getConfig(
  "EXTERNAL_INVESTOR_PORTAL_ENABLED_ORG_IDS",
) as string[];

const LOCAL_HOST = "http://localhost:3000";

// NOTE: `organization` must be the full document from `ReadMyOrganization`
//       (the backstage outlet context), not `identity.organization` which
//       is shaped by `UserOrganizationShape` and omits `linkTemplates`.
const getProjectScfUrl = (
  organization: Organization,
  projectId: string,
  sponsorId: string,
): string => {
  const { domain, id: organizationId } = organization;

  const isExternalInvestorPortalEnabled =
    EXTERNAL_INVESTOR_PORTAL_ENABLED_ORG_IDS.includes(organizationId);

  const defaultSoftCommitmentUrl = `https://${domain}`;
  const softCommitmentUrlTemplate = get(
    organization,
    "linkTemplates.softCommitmentUrl",
    defaultSoftCommitmentUrl,
  ) as string;

  const hasSoftCommitmentUrlTemplate =
    softCommitmentUrlTemplate !== defaultSoftCommitmentUrl;

  const shouldUseLinkTemplate =
    isExternalInvestorPortalEnabled && hasSoftCommitmentUrlTemplate;

  if (shouldUseLinkTemplate) {
    return softCommitmentUrlTemplate
      .trim()
      .replace("{projectId}", projectId)
      .replace("{sponsorId}", sponsorId);
  }

  const host = isLocal ? LOCAL_HOST : `https://${domain}`;
  const url = `${host}/scf/create/${projectId}/${sponsorId}`;

  return url;
};

export default getProjectScfUrl;
